import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EmployeeJobStepUp } from '@ups/xplat/api/dto';
import {
  environment,
  MyHttpClientFactory,
  ResponseCasingEnum,
} from '@ups/xplat/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TimekeepingStepUpService {
  httpFactory = inject(MyHttpClientFactory);
  http: HttpClient;

  constructor() {
    const url = environment.urls.spartaAPI;
    this.http = this.httpFactory.createHttpClient(
      url,
      true,
      ResponseCasingEnum.CamelCase
    );
  }

  getStepUps(employeeJobID: string): Observable<EmployeeJobStepUp[]> {
    return this.http.get(
      `/api/timekeeping/${employeeJobID}/stepUps`
    ) as Observable<EmployeeJobStepUp[]>;
  }

  saveStepUp(dto: EmployeeJobStepUp) {
    const url = '/api/timekeeping/stepUp';
    return this.http.post(url, dto);
  }
}
